import React, {useEffect} from 'react';
import { BrowserRouter , Routes, Route } from 'react-router-dom';
import { atom, useAtom } from 'jotai';
import { QueryClient, QueryClientProvider } from 'react-query';

import Header from './components/Structure/Header';
import Footer from './components/Structure/Footer';
import ScrollToTop from './components/Utility/ScrollToTop';
import ActualPage from './components/Utility/ActualPage';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Detail from './pages/Books/Detail';
import QuickSearch from './pages/Books/QuickSearch';
import AdvancedSearch from "./pages/Books/AdvancedSearch";
import Error from "./pages/Error";

export const darkModeAtom = atom(false);
const queryClient = new QueryClient();

function App() {
    const [darkMode] = useAtom(darkModeAtom);

    useEffect(() => {
        if (darkMode) {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    }, [darkMode]);

    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <div className="App max-w-7xl mx-auto">
                    <header className="App-header">
                        <Header />
                        <ActualPage />
                    </header>

                    <main className="App-main">
                        <Routes>
                            <Route path="/" element={<Home />}/>
                            <Route path="/recherche" element={<QuickSearch />}/>
                            <Route path="/a-propos/" element={<About />}/>
                            <Route path="/recherche-avancee" element={<AdvancedSearch />}/>
                            <Route path="/detail/:id" element={<Detail />}/>
                            <Route path="/contact/" element={<Contact />}/>
                            <Route path="*" element={<Error />}/>
                        </Routes>
                    </main>

                    <footer className="App-footer">
                        <Footer />
                    </footer>
                </div>

                <ScrollToTop />
            </BrowserRouter>
        </QueryClientProvider>
    );
}

export default App;